import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PageChangedEvent } from "ngx-bootstrap/pagination/public_api";
import { IPagination } from './model/IPagination';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationCustomComponent implements OnInit {
  // @Input() totalItems;
  // @Input() pagedItems: any[] = [];
  // @Input() itemsPerPage = 15;
  // @Input() currentPage = 1;
  @Input() paginationDetails: IPagination;
  @Input() isDetailsPageShow: boolean;
  @Output() onPageChange = new EventEmitter<any>();
  @Output() onPageNumberChange = new EventEmitter<any>();

  totalPage: number;
  constructor(private cd: ChangeDetectorRef, private translate: TranslateService) { }
  ngOnInit() {
    this.totalPage = Math.round(this.paginationDetails.totalItems / this.paginationDetails.itemsPerPage);
  }

  setPage(page: number) {
    this.paginationDetails.currentPage = page;
    // this.cd.detectChanges();
  }

  pageChanged(event: PageChangedEvent): void {
    console.log(event)
    // setTimeout(() => {
    //   this.onPageChange.emit(event.page);
    // }, 300)
    this.setPage(event.page);
    this.onPageChange.emit(event.page);
    // this.cd.detectChanges();
  }

  onSelectChange(event) {
    console.log(event.target.value);
    this.onPageNumberChange.emit(event.target.value);
  }

}
